import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
//CSS
import './DatosCV.css';

//img
import logoRed from '../../assets/img/myflogo-rrhh.png';
import team from '../../assets/img/rrhh/team.png';
import ganadores from '../../assets/img/rrhh/ganadores.png';
import camion from '../../assets/img/rrhh/camion.png';
import subitucv from '../../assets/img/rrhh/subituCV.png';
import {createAplicacionLaboral, saveCreateAplicacionLaboral} from "../../actions/AplicacionLaboralActions";
import {fetchPromocionesIfNeeded} from "../../actions/PromocionesActions";
import MensajeError from "../../layout/Mensajes/MensajeError";
import MensajeCorrecto from "../../layout/Mensajes/MensajeCorrecto";


class DatosCV extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.labelRef = null;
        this.state = {file: null};
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.aplicacionesLaborales.create && prevProps.aplicacionesLaborales && prevProps.aplicacionesLaborales.create &&
            !this.props.aplicacionesLaborales.create.isCreating && prevProps.aplicacionesLaborales.create.isCreating &&
            !this.props.aplicacionesLaborales.create.error) {
            this.setState({file: null});
            this.labelRef.innerHTML = "Seleccionar Archivo";
        }
    }

    handleChangeFile(e) {
        for (let i = 0; i < e.target.files.length; i++) {
            this.labelRef.innerHTML = e.target.files[i].name;
            this.setState({file: e.target.files[i]});
        }
    }

    handleChangeAplicacionLaboral(e) {
        let cambio = {};
        cambio[e.target.id ? e.target.id : e.target.name] = e.target.value;
        this.props.createAplicacionLaboral(cambio);
    }

    handleChangeArea(e) {
        let cambio = {};
        cambio[e.target.name] = e.target.checked ? e.target.value : null;
        this.props.createAplicacionLaboral(cambio);

    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.state.file)
            this.props.saveCreateAplicacionLaboral(this.state.file)
        else
            alert("No hay archivo seleccionado");

    }

    render() {
        let aplicacionLaboral = this.props.aplicacionesLaborales.create.nuevo;
        return (
            <div className="seccion-rrhh">
                <div className="section-rrhh-portada">
                    <div className="container-limit">
                        <div className="logo-myf-rrhh">
                            <Link to={"/"}>
                                <img src={logoRed} alt=""/>
                            </Link>
                        </div>
                        <div className="container-doble">
                            <div className="col-50">
                                <h4>Formá parte de <b>nuestro equipo</b></h4>
                                <h1>
                                    <b>Trabajá</b> <br/>con nosotros
                                </h1>
                            </div>
                            <div className="col-50">
                                <img className="team-rrhh" src={team} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="container-rrhh-red">
                    <div className="container-doble forma-crecer">
                        <div className="col-50 descripcion-rrhh">
                            <img src={ganadores} alt=""/>
                        </div>
                        <div className="col-50" style={{paddingLeft: "25px", paddingRight: "25px"}}>
                            <h2>
                                La mejor <br/>
                                <b>forma de</b> <br/>
                                <span>crecer</span>
                            </h2>
                            <p>
                                Buscamos profesionales que tengan vocación por la satisfacción de nuestros
                                clientes, que entiendan sus necesidades y se pongan en su lugar para brindar un
                                servicio ágil, dinámico y de calidad.
                                Si querés desarrollarte y cumplir tus metas, sumate a <b>nuestro equipo</b>.
                            </p>
                        </div>
                    </div>
                    <div className="lideres-distribucion">
                        <div className="container-limit" style={{position: "relative"}}>
                            <h2>
                                <b>Somos líderes en</b> <br/>
                                <span>distribución</span>
                            </h2>
                            <p>
                                Atendemos mas de 5.000 puntos de venta en nuestra región brindando una atención
                                transparente para que cada cliente tome las mejores decisiones.
                            </p>
                            <img src={camion} alt=""/>
                        </div>
                    </div>
                </section>
                <section className="subitu-cv">
                    <div className="container-limit">
                        <div className="formulario-cv">
                            <h2>
                                Subí tu CV
                            </h2>
                            <form onSubmit={(e) => this.handleSubmit(e)}>
                                <div className="container-doble rrhh-cv">
                                    <div className="col-50">
                                        <form action="">
                                            <div className="campo-input">
                                                <label htmlFor="">Nombre*</label>
                                                <input type="text" id="nombre" name={"nombre"}
                                                       value={aplicacionLaboral && aplicacionLaboral.nombre ? aplicacionLaboral.nombre : ""}
                                                       onChange={(e) => this.handleChangeAplicacionLaboral(e)}
                                                       required
                                                />
                                            </div>
                                            <div className="campo-input">
                                                <label htmlFor="">Apellido*</label>
                                                <input type="text" id="apellido" name={"apellido"}
                                                       value={aplicacionLaboral && aplicacionLaboral.apellido ? aplicacionLaboral.apellido : ""}
                                                       onChange={(e) => this.handleChangeAplicacionLaboral(e)}
                                                       required
                                                />
                                            </div>
                                            <div className="campo-input">
                                                <label htmlFor="">E-mail*</label>
                                                <input type="email" id="email" name={"email"}
                                                       value={aplicacionLaboral && aplicacionLaboral.email ? aplicacionLaboral.email : ""}
                                                       onChange={(e) => this.handleChangeAplicacionLaboral(e)}
                                                       required/>
                                            </div>
                                            <div className="campo-input">
                                                <label htmlFor="">Celular*</label>
                                                <input type="text" id="celular" name={"celular"}
                                                       value={aplicacionLaboral && aplicacionLaboral.celular ? aplicacionLaboral.celular : ""}
                                                       onChange={(e) => this.handleChangeAplicacionLaboral(e)}
                                                       required
                                                />
                                            </div>
                                            <div className="campo-input">
                                                <label htmlFor="">Selecciona Area*</label>
                                                <div className="radio-area">
                                                    <p>
                                                        <input type="radio" value="Administración" id="admin"
                                                               name="area"
                                                               onChange={(e) => this.handleChangeArea(e)}
                                                               required
                                                               checked={aplicacionLaboral.area === "Administración"}
                                                        />
                                                        <label htmlFor="admin">Administración</label>
                                                    </p>
                                                    <p>
                                                        <input type="radio" value="Depósito" id="deposito" name="area"
                                                               onChange={(e) => this.handleChangeArea(e)}
                                                               required
                                                               checked={aplicacionLaboral.area === "Depósito"}/>
                                                        <label htmlFor="deposito">Depósito</label>
                                                    </p>
                                                    <p>
                                                        <input type="radio" value="Ventas" name="area" id="ventas"
                                                               onChange={(e) => this.handleChangeArea(e)}
                                                               required
                                                               checked={aplicacionLaboral.area === "Ventas"}/>
                                                        <label htmlFor="ventas">Asesor de ventas</label>
                                                    </p>
                                                    <p>
                                                        <input type="radio" value="Otra" name="area" id="otra"
                                                               onChange={(e) => this.handleChangeArea(e)}
                                                               required
                                                               checked={aplicacionLaboral.area === "Otra"}/>
                                                        <label htmlFor="otra">Otra</label>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="campo-input">
                                                <label htmlFor="mensaje">Mensaje</label>
                                                <textarea name="mensaje" id="mensaje" cols="30" rows="3"
                                                          value={aplicacionLaboral && aplicacionLaboral.mensaje ? aplicacionLaboral.mensaje : ""}
                                                          onChange={(e) => this.handleChangeAplicacionLaboral(e)}
                                                />
                                            </div>
                                            <div className="campo-input">
                                                <label htmlFor="file">Subir archivo (.pdf, .doc)*</label>
                                                <div className="file-input">
                                                    <label htmlFor="file" ref={instance => this.labelRef = instance}>
                                                        Seleccionar Archivo
                                                    </label>
                                                    <input type="file" name="file" id="file" className="inputfile"
                                                           accept=".doc,.docx,.pdf"
                                                           onChange={(e) => this.handleChangeFile(e)}
                                                           required
                                                    />
                                                </div>
                                            </div>
                                            <label htmlFor="" style={{
                                                fontSize: "10px",
                                                fontWeight: 100,
                                                fontStyle: "oblique",
                                                float: "left",
                                                fontFamily: "MyriadPro"
                                            }}>
                                                * Campos obligatorios
                                            </label>

                                            <button type="submit"
                                                    className={`${this.props.aplicacionesLaborales.create.isCreating ? "disabled" : ""} enviarCV`}
                                                    disabled={this.props.aplicacionesLaborales.create.isCreating}>
                                                Enviar
                                            </button>


                                        </form>
                                    </div>
                                    <div className="col-50">
                                        <img className="icono-girl-cv" src={subitucv} alt=""/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
                <section className="modal-cv"
                         style={{display: this.props.aplicacionesLaborales.create.isCreating ? "flex" : "none"}}>
                    <div className="modal-cv-body">
                        <div className="modal-spiner">
                            <div className="loader">Loading...</div>
                        </div>
                        <div className="modal-text">
                            Aguarde un momento
                        </div>
                    </div>
                </section>
                <MensajeError/>
                <MensajeCorrecto/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        aplicacionesLaborales: state.aplicacionesLaborales
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveCreateAplicacionLaboral: (files) => {
            dispatch(saveCreateAplicacionLaboral(files))
        },
        createAplicacionLaboral: (aplicacionLaboral) => {
            dispatch(createAplicacionLaboral(aplicacionLaboral))
        },
        fetchPromocionesIfNeeded: () => {
            dispatch(fetchPromocionesIfNeeded());
        }

    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DatosCV));


// WEBPACK FOOTER //
// ./src/pages/RRHHPage/DatosCV.js